module.exports = __webpack_public_path__ + "media/volvo/assets/images/twitter@2x-3cafe3ffa33e426570ef52a5da931ae4.png";